import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "method-icon-wrap" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "method-name" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "method-wrap"
}
const _hoisted_6 = { class: "method-icon-wrap" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "method-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TooltipHover = _resolveComponent("TooltipHover")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["deposit-method", { active: _ctx.active, disabled: _ctx.disabled }])
  }, [
    (_ctx.disabled)
      ? (_openBlock(), _createBlock(_component_TooltipHover, {
          key: 0,
          class: "method-wrap"
        }, {
          root: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("img", {
                src: _ctx.icon,
                class: "method-icon"
              }, null, 8, _hoisted_2)
            ]),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.nameNormalized), 1),
            _createElementVNode("img", {
              src: require('../../assets/icons/warning.svg'),
              class: "method-warning"
            }, null, 8, _hoisted_4)
          ]),
          text: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('DepositContainer.disabled')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: _ctx.icon,
              class: "method-icon"
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.nameNormalized), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}